// One CSV cell: quoted, with spreadsheet formulas neutralised.
export function csvCell(value: string): string {
  const safe = /^[=+\-@]/.test(value) && !/^-?\d+(\.\d+)?$/.test(value) ? `'${value}` : value;
  return `"${safe.replace(/"/g, '""')}"`;
}

export function csvText(rows: string[][]): string {
  return `${rows.map(row => row.map(csvCell).join(',')).join('\r\n')}\r\n`;
}
